// @deno-types="@types/react"
import React, { Suspense, PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";

export function QueryBoundary({ children, fallback }: PropsWithChildren<{ fallback: React.ReactNode }>) {
  return (
    <ErrorBoundary
      FallbackComponent={({ error }) => (
        <div role="alert">{error instanceof Error ? error.message : "Something went wrong"}</div>
      )}
    >
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  );
}

export default QueryBoundary;
